import { type RequestPayload, router } from "@inertiajs/core";
import { ObservationForm } from "../../components/observation/ObservationForm";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import type { Apprentice } from "../../models/apprentice";
import { observations_path } from "../../routes";

type ObservationCreateProps = {
  apprentices: Apprentice[];
};

export default function ObservationCreate({ apprentices }: ObservationCreateProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(observations_path), values);

  return (
    <ContentShell title="Beobachtungen">
      <ObservationForm saveButtonLabel="Erstellen" apprentices={apprentices} onSubmit={onSubmit} />
    </ContentShell>
  );
}
